<mat-card appearance="outlined" class="change-history-card" [cfaLoading]="isLoading() && !shouldSkipLoadingIndicator()">
    <div class="row">
        <div class="col-auto align-self-center pr-0">
            <button *ngIf="epochColumn" mat-icon-button (click)="showTimelinePane()"
                    [disabled]="getMaxDayOffset() === 0">
                <mat-icon [class.cfa-primary]="shouldShowTimeline()">timeline</mat-icon>
            </button>
        </div>
        <div class="col align-self-center">
            <mat-form-field #searchField color="primary" class="w-100">
                <mat-label>{{searchPlaceholder}}</mat-label>
                <mat-chip-grid #chipList class="nowrapChipList">
                    <mat-chip-row *ngFor="let searchOption of getSearchOptions()" class="filter-chip" [editable]="true"
                              [removable]="true" (removed)="removeSearchOption(searchOption)"
                              (click)="editSearchOption(searchOption)">
                        <span *ngIf="searchOption.type === 'contains'">Contains: </span>
                        <span *ngIf="searchOption.type === 'starts with'">Starts With: </span>
                        <span *ngIf="searchOption.type === 'ends with'">Ends With: </span>
                        {{searchOption.text}}
                        <span *ngIf="searchOption.columnProperty !== null"> - in
                            "{{ searchOption.columnLabel }}"</span>
                        <mat-icon matChipRemove class="filter-chip-remove">cancel</mat-icon>
                    </mat-chip-row>
                    <input #searchInput [matChipInputFor]="chipList" class="searchInput"
                           [matChipInputSeparatorKeyCodes]="separatorKeysCodes" (matChipInputTokenEnd)="addFilter()"
                           (keyup)="searchKeyUp($event)" autocomplete="off">
                    <div class="search-properties-container" [@fadeInSearch]="'active'"
                         *ngIf="shouldShowSearchProperties() && hasActiveSearchOption()">
                        <div class="row">
                            <div class="col search-property-scroll">
                                <h5 class="search-category">Type:</h5>
                                <h5 class="search-option" [class.active]="getActiveSearchOption().type === 'contains'"
                                    (click)="changeSearchType('contains')">Contains</h5>
                                <h5 class="search-option"
                                    [class.active]="getActiveSearchOption().type === 'exact match'"
                                    (click)="changeSearchType('exact match')">Exact Match</h5>
                                <h5 class="search-option"
                                    [class.active]="getActiveSearchOption().type === 'starts with'"
                                    (click)="changeSearchType('starts with')">Starts With</h5>
                                <h5 class="search-option" [class.active]="getActiveSearchOption().type === 'ends with'"
                                    (click)="changeSearchType('ends with')">Ends With</h5>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col search-property-scroll">
                                <h5 class="search-category">Column:</h5>
                                <h5 class="search-option" *ngFor="let option of getSearchableOptions()"
                                    [class.active]="getActiveSearchOption().columnProperty === option.columnProperty"
                                    [class.disabled]="option.columnProperty === null && getActiveSearchOption().type !== 'contains'"
                                    (click)="changeSearchOption(option)">{{option.columnLabel}}</h5>
                            </div>
                        </div>
                    </div>
                </mat-chip-grid>
            </mat-form-field>
        </div>
        <div class="col-auto align-self-center pl-0 pr-0">
            <button mat-icon-button (click)="showFilterPane()">
                <mat-icon [class.cfa-primary]="shouldShowFilters()">filter_alt</mat-icon>
            </button>
        </div>
        <div class="col-auto align-self-center pl-0">
            <button mat-icon-button (click)="refreshData()" color="primary"
                    [cfaLoading]="isLoading() && !shouldSkipLoadingIndicator()">
                <mat-icon>refresh</mat-icon>
            </button>
        </div>
    </div>
    <div class="cfa-data-table" (click)="closePanes()"
         [@shrinkForTimeline]="shouldShowTimeline() ? 'timeline' : (shouldShowFilters() ? 'filter' : (shouldShowSearchProperties() && hasActiveSearchOption() ? 'search' : 'normal'))">
        <div class="cfa-data-table-header" cdkScrollable #headerScroll>
            <div *ngIf="selectable" class="cfa-data-table-col select" [style.height]="'50px'">
                <mat-checkbox class="cfa-data-table-checkbox" [checked]="allSelected()"
                              [indeterminate]="someSelected()" (change)="selUnSelAll($event)"></mat-checkbox>
            </div>
            <div *ngIf="epochColumn" class="cfa-data-table-col header" [style.width]="epochColumn.width">
                {{epochColumn.label}}
            </div>
            <ng-container *ngIf="dataColumns">
                <div *ngFor="let dataCol of dataColumns" class="cfa-data-table-col header"
                     [style.width]="dataCol.width">
                    {{dataCol.label}}
                </div>
            </ng-container>
        </div>
        <cdk-virtual-scroll-viewport itemSize="30" class="cfa-data-table-data" #dataScroll>
            <div *cdkVirtualFor="let dataEntry of filteredData" class="cfa-data-table-entry">
                <div *ngIf="selectable" class="cfa-data-table-col select" [style.width]="'50px'">
                    <mat-checkbox color="primary" class="cfa-data-table-checkbox" [checked]="isSelected(dataEntry)"
                                  (change)="selUnsel($event, dataEntry)"></mat-checkbox>
                </div>
                <div class="cfa-data-table-col" *ngIf="epochColumn" [style.width]="epochColumn.width"
                     [attr.data-text]="dataEntry[epochColumn.displayProperty]"
                     (click)="copyToClipboard(dataEntry[epochColumn.displayProperty])">
                    {{dataEntry[epochColumn.displayProperty]}}
                </div>
                <ng-container *ngIf="dataColumns">
                    <div *ngFor="let dataCol of dataColumns" class="cfa-data-table-col"
                         [style.width]="dataCol.width" [attr.data-text]="dataEntry[dataCol.property]"
                         (click)="copyToClipboard(dataEntry[dataCol.property])">
                        {{dataEntry[dataCol.property]}}
                    </div>
                </ng-container>
            </div>
        </cdk-virtual-scroll-viewport>
    </div>

    <div class="history-slider-pane" [@slideInTimeline]="shouldShowTimeline() ? 'active' : 'inactive'">
        <div class="history-slider-container">
            <div class="row">
                <div class="col text-right">
                    <h4 class="pane-header">Timeline</h4>
                </div>
            </div>
            <!-- TODO: The 'vertical' property no longer exists -->
            <!-- TODO: The 'invert' property no longer exists -->
            <!-- TODO: The 'tickInterval' property no longer exists -->
            <mat-slider class="history-slider" color="primary" [min]="0"
                        [max]="getMaxDayOffset()" step="1" thumbLabel
                        [displayWith]="getDayOffsetLabel.bind(this)" [(ngModel)]="dayOffset" [disabled]="!hasFilteredData()" #ngSlider><input matSliderThumb /><input matSliderThumb (input)="historySliderChange({source: ngSliderThumb, parent: ngSlider, value: ngSliderThumb.value})" #ngSliderThumb="matSliderThumb" />
            </mat-slider>
        </div>
    </div>

    <div class="filter-pane" [@slideInFilters]="shouldShowFilters() ? 'active' : 'inactive'">
        <div class="row mb-2">
            <div class="col text-left">
                <h4 class="pane-header">Filters</h4>
            </div>
        </div>
        <div class="row mb-2" *ngFor="let filterOption of filterOptions">
            <div class="col-12">
                <h5 class="filter-pane-category-header">{{filterOption.columnLabel}}</h5>
            </div>
            <div class="offset-1 col-11 filter-pane-options">
                <div class="row" *ngFor="let option of filterOption.options">
                    <div class="col">
                        <mat-checkbox color="primary" [checked]="isFiltered(filterOption, option)"
                                      (change)="toggleFilter($event, filterOption, option)">
                            {{option}}
                        </mat-checkbox>
                    </div>
                </div>
            </div>
        </div>
    </div>
</mat-card>
